import React from "react";
import SecondaryHeading from "../../components/common/Typography/SecondaryHeading";
import Paragraph from "../../components/common/Typography/Paragraph";

const ServiceAreas = ({ userData, className = "" }) => {
  // Fallback data when userData is not available or serviceAreas is empty
  const fallbackAreas = [
    "Richmond", "Fitzroy", "Carlton", "South Yarra", 
    "Collingwood", "North Melbourne", "East Melbourne", "West Melbourne",
    "St Kilda", "Prahran"
  ];

  // Get service areas from userData or use fallback
  const serviceAreas = userData?.serviceAreas && userData.serviceAreas.length > 0 
    ? userData.serviceAreas 
    : fallbackAreas;

  return (
    <div className={`mb-8 ${className}`}>
      <div>
        <SecondaryHeading variant={"MainParagraphHeading"} className={"text-offblack mb-4"}>
          Service Areas
        </SecondaryHeading>
        <div className="grid grid-cols-2 gap-1">
          {serviceAreas.slice(0, 10).map((area, index) => (
            <Paragraph key={index} variant={"MainParagraph"} className="text-offblack">
              {area}
            </Paragraph>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServiceAreas;
